import { render, staticRenderFns } from "./activitytemplate2.vue?vue&type=template&id=6e226f10&scoped=true"
import script from "./activitytemplate2.vue?vue&type=script&lang=js"
export * from "./activitytemplate2.vue?vue&type=script&lang=js"
import style0 from "./activitytemplate2.vue?vue&type=style&index=0&id=6e226f10&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../opt/build-cache/yunying/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e226f10",
  null
  
)

export default component.exports